import axios from "axios";
import { COMMON_API_URL } from "../../api_endpoints/API_URL";

// Action (names)
export const SHOW_LOADER = "SHOW_LOADER";
export const SHOW_TOAST = "SHOW_TOAST";
export const SHOW_CHAT = "SHOW_CHAT";
export const UPDATE_LOGGED_IN_ROUTE = "UPDATE_LOGGED_IN_ROUTE"
export const GET_SERVICES_LIST = "GET_SERVICES_LIST";
export const GET_SUBJECTS_LIST = "GET_SUBJECTS_LIST";
export const GET_ACADEMIC_LEVEL_LIST = "GET_ACADEMIC_LEVEL_LIST";
export const GET_CANCEL_REASON_LIST = "GET_CANCEL_REASON_LIST";
export const GET_UNIVERSITIES_LIST = "GET_UNIVERSITIES_LIST";
export const GET_ASSIGNMENT_TYPE_LIST = "GET_ASSIGNMENT_TYPE_LIST";
export const GET_REFERENCING_STYLE_LIST = "GET_REFERENCING_STYLE_LIST";
export const GET_SOFTWARE_REQUIRED_LIST = "GET_SOFTWARE_REQUIRED_LIST";
export const GET_HIGHEST_DEGREE_LIST = "GET_HIGHEST_DEGREE_LIST";
export const GET_SPECIALIZATION_LIST = "GET_SPECIALIZATION_LIST";
export const GET_COUNTRIES_LIST = "GET_COUNTRIES_LIST";
export const GET_OUTSOURCED_TASKS_LIST = "GET_OUTSOURCED_TASKS_LIST";
export const GET_WORD_COUNT_LIST = "GET_WORD_COUNT_LIST";
export const REMOVE_COMMON_STATE = "REMOVE_COMMON_STATE"
export const GET_CONTENT_TEAM_SPECIALIZATION_LIST = "GET_CONTENT_TEAM_SPECIALIZATION_LIST";
export const GET_CONTENT_WRITER_SPECIALIZATION_LIST = "GET_CONTENT_WRITER_SPECIALIZATION_LIST";
export const GET_CONTENT_WRITING_INDUSTRIES_LIST = "GET_CONTENT_WRITING_INDUSTRIES_LIST";
export const GET_CONTENT_WRITER_INDUSTRIES_LIST = "GET_CONTENT_WRITER_INDUSTRIES_LIST";
export const GET_CONTENT_WRITING_TEAM_STRENGTH_LIST = "GET_CONTENT_WRITING_TEAM_STRENGTH_LIST";


export const showLoader = (data) => {
  const actionObject = {
    type: SHOW_LOADER,
    payload: data,
  };
  return actionObject;
};

export const showToast = (data) => {
  const actionObject = {
    type: SHOW_TOAST,
    payload: data,
  };
  return actionObject;
};

export const showChat = (data) => {
  const actionObject = {
    type: SHOW_CHAT,
    payload: data,
  };
  return actionObject;
};

export const setLoggedInPath = (data) => {
  const actionObject = {
    type: UPDATE_LOGGED_IN_ROUTE,
    payload: data,
  };
  return actionObject;
};

export const saveHighestDegreeList = (data) => {
  const actionObject = {
    type: GET_HIGHEST_DEGREE_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveSpecializationList = (data) => {
  const actionObject = {
    type: GET_SPECIALIZATION_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveAssignmentList = (data) => {
  const actionObject = {
    type: GET_ASSIGNMENT_TYPE_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveCancelReasonList = (data) => {
  const actionObject = {
    type: GET_CANCEL_REASON_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveServiceList = (data) => {
  const actionObject = {
    type: GET_SERVICES_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveSubjectsList = (data) => {
  const actionObject = {
    type: GET_SUBJECTS_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveAcademicLevelList = (data) => {
  const actionObject = {
    type: GET_ACADEMIC_LEVEL_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveUniversityList = (data) => {
  const actionObject = {
    type: GET_UNIVERSITIES_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveSoftReqList = (data) => {
  const actionObject = {
    type: GET_SOFTWARE_REQUIRED_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveRefStyleList = (data) => {
  const actionObject = {
    type: GET_REFERENCING_STYLE_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveCountriesList = (data) => {
  const actionObject = {
    type: GET_COUNTRIES_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveOutsourcedTasksList = (data) => {
  const actionObject = {
    type: GET_OUTSOURCED_TASKS_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveWordCountList = (data) => {
  const actionObject = {
    type: GET_WORD_COUNT_LIST,
    payload: data,
  };
  return actionObject;
};

export const saveContentTeamSpecializationList = (data) => {
  const actionObject = {
    type: GET_CONTENT_TEAM_SPECIALIZATION_LIST,
    payload: data,
  };
  return actionObject;
};
export const saveContentWriterSpecializationList = (data) => {
  const actionObject = {
    type: GET_CONTENT_WRITER_SPECIALIZATION_LIST,
    payload: data,
  };
  return actionObject;
};
export const saveContentWritingIndustriesList = (data) => {
  const actionObject = {
    type: GET_CONTENT_WRITING_INDUSTRIES_LIST,
    payload: data,
  };
  return actionObject;
};
export const saveContentWriterIndustriesList = (data) => {
  const actionObject = {
    type: GET_CONTENT_WRITER_INDUSTRIES_LIST,
    payload: data,
  };
  return actionObject;
};
export const saveContentWritingTeamStrengthList = (data) => {
  const actionObject = {
    type: GET_CONTENT_WRITING_TEAM_STRENGTH_LIST,
    payload: data,
  };
  return actionObject;
};

export const removeCommonState = () => {
  const actionObject = {
    type: REMOVE_COMMON_STATE,
  };
  return actionObject;
};

export const fetchAllList = (type) => (dispatch) => {
  // const token = `Bearer ${tkn}`;
  axios({
    url: COMMON_API_URL + "/" + type,
    method: "GET",
    headers: {
      // authorization: token,
    },
    // data: {},
  })
    .then((results) => {
      switch (type) {
        case "assignmentTypeList":
          dispatch(saveAssignmentList(results.data));
          break;

        case "cancellationReason":
          dispatch(saveCancelReasonList(results.data));
          break;

        case "services":
          dispatch(saveServiceList(results.data));
          break;

        case "subjects":
          dispatch(saveSubjectsList(results.data));
          break;

        case "academicLevel":
          dispatch(saveAcademicLevelList(results.data));
          break;

        case "softwareRequired":
          dispatch(saveSoftReqList(results.data));
          break;

        case "university":
          dispatch(saveUniversityList(results.data));
          break;

        case "referencingStyle":
          dispatch(saveRefStyleList(results.data));
          break;

        case "highestDegree":
          dispatch(saveHighestDegreeList(results.data));
          break;

        case "specialization":
          dispatch(saveSpecializationList(results.data));
          break;

        case "fetchCountries":
          dispatch(saveCountriesList(results.data));
          break;

        case "tasksOutsourced":
          dispatch(saveOutsourcedTasksList(results.data));
          break;

        case "wordCount":
          dispatch(saveWordCountList(results.data));
          break;

        case "contentTeamSpecialization":
          dispatch(saveContentTeamSpecializationList(results.data));
          break;

        case "contentWriterSpecialization":
          dispatch(saveContentWriterSpecializationList(results.data));
          break;

        case "contentWritingIndustries":
          dispatch(saveContentWritingIndustriesList(results.data));
          break;
        case "contentWriterIndustries":
          dispatch(saveContentWriterIndustriesList(results.data));
          break;
        case "contentWritingTeamStrength":
          dispatch(saveContentWritingTeamStrengthList(results.data));
          break;

        default:
          break;
      }
    })
    .catch((error) => {});
};
